<template>
  <WebPanelPage class="ui-icons-route" title="Icons">
    <div class="flex mb5">
      <BreadcrumbNav
        :items="[
          { name: 'UI Components', routerLink: { name: 'ui-index' } },
          { name: 'Icons' },
        ]"
      ></BreadcrumbNav>
    </div>
    <div class="grid">
      <div class="bg-white pa3 w-100" v-for="icon in icons" :key="icon">
        <RatioContainer :ratio="100">
          <div class="flex flex-column item-center justify-center h-100">
            <UIIcon class="h-50 w-30 center db" :name="icon"></UIIcon>
            <pre class="f-instructions tc">{{icon}}</pre>
          </div>
        </RatioContainer>
      </div>
    </div>
  </WebPanelPage>
</template>
<script>
import BreadcrumbNav from '@sbvr/common/legacy-shared/components/BreadcrumbNav';
import WebPanelPage from '@sbvr/web-panel/WebPanelPage';
import UIIcon from '@sbvr/ui/UIIcon';
import RatioContainer from '@sbvr/common/legacy-shared/components/utils/RatioContainer';
import { onMounted, ref } from '@vue/composition-api';

export default {
  name: 'UIIconsRoute',
  components: {
    WebPanelPage,
    BreadcrumbNav,
    RatioContainer,
    UIIcon,
  },
  setup () {
    const icons = ref([]);
    onMounted(function () {
      icons.value = Array.from(document.querySelectorAll('symbol')).map((el) => {
        return el.id.replace(/^icon-/, '');
      });
    });
    return { icons };
  },
};
</script>

<style lang="postcss" scoped>
.ui-icons-route {
  & .grid {
    display: grid;
    grid-gap: 3rem;
    grid-template-columns: repeat(auto-fit, minmax(10vw, auto));
  }
}
</style>
